export const SUBMIT_TIME_ENTRY = 'SUBMIT_TIME_ENTRY';
export const SUBMIT_TIME_ENTRY_SUCCESS = 'SUBMIT_TIME_ENTRY_SUCCESS';
export const SUBMIT_TIME_ENTRY_ERROR = 'SUBMIT_TIME_ENTRY_ERROR';

export const HANDLE_TIME_ENTRY_INPUT_CHANGE = 'HANDLE_TIME_ENTRY_INPUT_CHANGE';

export const UPDATE_SELECTED_DAYS = 'UPDATE_SELECTED_DAYS';

export const SET_SHOW_BULK_ENTRY_MODAL = 'SET_SHOW_BULK_ENTRY_MODAL';

export const LOADING_ADD_TASK = 'LOADING_ADD_TASK';
export const LOADING_ADD_TASK_SUCCESS = 'LOADING_ADD_TASK_SUCCESS';
export const LOADING_ADD_TASK_ERROR = 'LOADING_ADD_TASK_ERROR';

export const ADD_TIME_ENTRY_BULK = 'ADD_TIME_ENTRY_BULK';
export const ADD_TIME_ENTRY_BULK_SUCCESS = 'ADD_TIME_ENTRY_BULK_SUCCESS';
export const ADD_TIME_ENTRY_BULK_ERROR = 'ADD_TIME_ENTRY_BULK_ERROR';

export const REMOVE_PROJECT_ENTRY = 'REMOVE_PROJECT_ENTRY';

export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

export const LOADING_CALENDAR_COMPLETION = 'LOADING_CALENDAR_COMPLETION';
export const LOADING_CALENDAR_COMPLETION_SUCCESS = 'LOADING_CALENDAR_COMPLETION_SUCCESS';
export const LOADING_CALENDAR_COMPLETION_ERROR = 'LOADING_CALENDAR_COMPLETION_ERROR';

export const SETUP_CATEGORIES = 'SETUP_CATEGORIES';

export const UPDATE_HOURS_ENTERED = 'UPDATE_HOURS_ENTERED';